import "./LayoutSelectionSlider.css";
import {
  React,
  useEffect,
  memo,
  Radio,
  useGetLayoutImagesMutation,
  useState,
  Box,
  LoadingSpinner,
  GetCookie,
} from "../../../Libraries/Post/AddNewPost/Child/LayoutSelectionSlider/index";
import { BASEURL } from "../../../Utils/Constants/constants";
import RadioGroup from "@mui/material/RadioGroup";
import layout1 from "../../../Assets/layouts/1.jpg";
import layout2 from "../../../Assets/layouts/2.jpg";
import layout3 from "../../../Assets/layouts/3.jpg";
import layout4 from "../../../Assets/layouts/4.jpg";
import layout5 from "../../../Assets/layouts/5.jpg";
import layout6 from "../../../Assets/layouts/6.jpg";

const LayoutSelection = ({ data, handleChangeSelectedLayout, currentScreen }) => {

  const [getAllLayouts, { isLoading }] = useGetLayoutImagesMutation();
  const [layouts, setLayouts] = useState([]);

  useEffect(() => {
    const getAllLayoutsfun = async () => {
      try {
        const formData = new FormData();
        formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
        formData.append("security_token", await GetCookie("es_token"));

        const fetchOptions = {
          method: "POST",
          body: formData,
          cache: "no-cache",
          referrerPolicy: "no-referrer",
        };

        const response = await fetch(BASEURL + "layouts/getLayouts.php", fetchOptions);

        if (!response.ok) {
          console.error("Fetch error", response);
          setLayouts([]);
          return;
        }

        const res = await response.json();
        console.log(res);

        if (res?.status === "true" && res?.connection === "true") {
          setLayouts(res.data || []);
        } else {
          console.error("Error fetching layouts", res?.message);
          setLayouts([]);
        }
      } catch (error) {
        console.error("Layout fetch error", error);
        setLayouts([]);
      }
    };
    getAllLayoutsfun();
  }, [getAllLayouts]);

  const visibleLayouts =
  currentScreen.txt_orientation_type === "PORTRAIT"
    ? layouts.filter(
        (layout) =>
          layout.ser_layout_id === "1" || layout.ser_layout_id === "2"
      )
    : layouts;

    const layoutImages = {
  "1": layout1,
  "2": layout2,
  "3": layout3,
  "4": layout4,
  "5": layout5,
  "6": layout6
};

  return (
    <>
      {isLoading && <LoadingSpinner />}

      <Box sx={{ p: 2 }}>
        <RadioGroup
          value={String(data?.selectedLayout ?? "")}
          onChange={(e) => handleChangeSelectedLayout(Number(e.target.value))}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
              gap: 3,
            }}
          >
            {/* {layouts.map((layout) => { */}
            {visibleLayouts.map((layout) => {
              const layoutId = Number(layout.ser_layout_id);
              const selected = Number(data?.selectedLayout) === layoutId;

              return (
                <Box
                  key={layoutId}
                  onClick={() => handleChangeSelectedLayout(layoutId)}
                  sx={{
                    cursor: "pointer",
                    background: "#fff",
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: selected
                      ? "2px solid #1A75E8"
                      : "1px solid #A6C6E3",
                    boxShadow: selected
                      ? "0 0 0 2px rgba(26,117,232,0.2)"
                      : "none",
                    transition: "all 0.2s ease",
                  }}
                  
                >
                  {/* Header */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      px: 2,
                      py: 1,
                      borderBottom: "1px solid #A6C6E3",
                    }}
                  >
                    <Box sx={{ fontSize: "14px", fontWeight: 500 }}>
                      {layout.txt_layout_name}
                    </Box>

                    <Radio value={String(layoutId)} checked={selected} />
                  </Box>

                  {/* Image */}
                  <Box sx={{ p: 2 }}>
                    <img
                      src={layoutImages[String(layout.ser_layout_id)]}
                      alt="layout-preview"
                      style={{
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </RadioGroup>
      </Box>
    </>
  );
};

export default memo(LayoutSelection);
